import lodash from 'lodash';
import { diff } from './diff';
import { TranslationAction } from './types';

const { unset, get, set, cloneDeep } = lodash;

export function isNewKey(key: string) {
  return Boolean(diff.find((entry) => entry.newTermWithContext === key));
}

// Helper to set plural or singular translation
function applyTranslation(
  target: object,
  key: string,
  translation: TranslationAction['translation'],
) {
  if (typeof translation === 'object') {
    set(target, `${key}_one`, translation.one);
    set(target, `${key}_other`, translation.other);
  } else {
    set(target, key, translation);
  }
}

// Helper to copy existing translations
function copyExistingTranslations(target: object, oldKey: string, newKey: string) {
  const normal = get(target, oldKey);
  const one = get(target, `${oldKey}_one`);
  const other = get(target, `${oldKey}_other`);

  if (normal) set(target, newKey, normal);
  if (one) set(target, `${newKey}_one`, one);
  if (other) set(target, `${newKey}_other`, other);
}

// Helper to remove old keys
function removeOldTranslations(target: object, key: string) {
  unset(target, key);
  unset(target, `${key}_one`);
  unset(target, `${key}_other`);
}

export function mergeTranslations(oldTranslations: object) {
  const newTranslations = cloneDeep(oldTranslations);

  for (const item of diff) {
    const { currentTermWithContext, newTermWithContext, translation } = item;

    if (currentTermWithContext) {
      if (newTermWithContext) {
        if (translation) {
          applyTranslation(newTranslations, newTermWithContext, translation);
        } else {
          copyExistingTranslations(newTranslations, currentTermWithContext, newTermWithContext);
        }
      }
      removeOldTranslations(newTranslations, currentTermWithContext);
    } else if (newTermWithContext && translation) {
      applyTranslation(newTranslations, newTermWithContext, translation);
    }
  }

  return newTranslations;
}
